// export const baseUrl = "https://api.spiritritj.com";
// export const baseUrl = "http://34.101.246.188";
// export const baseUrl = 'http://localhost:4000';
export const baseUrl = 'https://api.spiritritj.com';

export const googleMapsApi = 'AIzaSyB4kFn1duR183wjPE4F2OFQHYRqW4c3dJE';
